module.exports = __webpack_public_path__ + "img/404.png";